import _ from 'lodash';

// NAMES

const names = {
	first: {
		cat: [
			'Meowy',
			'Purrty',
		],
		wildcat: [
			'Meowy',
			'Purrty',
			'Untamed',
			'Primitive',
			'Savage',
			'Fierce',
			'Powerful',
			'Wild',
		],
		penguin: [
			'Icy',
			'Frozen',
			'Winter',
			'Snowy',
			'Cold',
			'Chilly',
			'Arctic',
			'Hypothermic',
			'Frigid',
			'Cool',
			'Shivery',
			'Frosty',
			'Wobbly',
			'Bouncy',
			'Peppy',
		],
		dog: [
			'Barky',
			'Loyal',
			'Yappy',
			'Yippy',
			'Sheddy',
			'Drooly',
			'Borking',
			'Doggest',
			'Pupperest',
			'Borky',
			'Slobbery',
			'Fetching',
		],
		classicdoggo: [
			'Barky',
			'Loyal',
			'Yappy',
			'Yippy',
			'Sheddy',
			'Drooly',
			'Borking',
			'Doggest',
			'Pupperest',
			'Borky',
			'Slobbery',
			'Classy',
			'Labby',
			'Golden',
			'Fetching',
			'Well-Behaved',
			'Trained',
		],
		turtle: [
			'Shelly',
			'Round',
			'Dawdling',
			'Sluggish',
			'Patient',
			'Scaredy',
			'Galapagosian',
			'Gigantic',
			'Enormous',
		],
		bear: [
			'Rugged',
			'Grisly',
			'Tough',
			'Stout',
			'Vicious',
			'Honey Loving',
			'Growley',
			'Hibernating',
			'Winnie',
		],
		chicken: [
			'Flappy',
			'Clucking',
			'Peckish',
			'Birby',
		],
		seal: [
			'Slippery',
			'Chubby',
			'Round',
			'Slappy',
			'Blubbery',
			'Blobular',
			'Plump',
			'Portly',
			'Pudgy',
		],
		bunny: [
			'Hoppy',
			'Jumpy',
		],
		shared: [
			'Floppy',
			'Rolly Polly',
			'Clever',
			'Mischievous',
			'Ridiculous',
			'Gluttonous',
			'Sardonic',
			'Surly',
			'Boopable ',
			'Floofy ',
			'Smelly',
			'Dizzy',
			'Gooby',
			'Dooby',
			'Schmoopy',
			'Floopy',
			'Sniffly',
			'Spinning',
			'Cranky',
			'Excited',
			'Night',
			'Tiny',
			'Li\'l',
			'Magic',
			'Lord',
			'Master',
			'Teeny',
			'Froofy',
			'Poofy',
			'Cuddly',
			'Crabby',
			'Sleepy',
			'Grand',
			'Her Majesty, The Empress',
			'His Majesty, The Emperor',
			'Sparkly',
			'Young',
			'Old',
			'Petit',
			'Silent',
			'Furry',
			'Fluffy',
			'Shining',
			'Regal',
			'Cool',
			'Mysterious',
			'Notorious',
			'Sneaky',
			'Professor',
			'Doctor',
			'Cheeky',
			'Grand',
			'Crazy',
			'Stinky',
			'Corpulent',
			'Admiral',
			'General',
			'Tricky',
			'Scheming',
			'Sir',
			'Insane',
			'Lumpy',
			'Captain',
			'Unruly',
			'Splendiferous',
			'Criminal',
			'Swift',
			'Crumply',
			'Blessed',
			'Curmudgeonly',
			'Slow',
			'Leaping',
			'Wobbly',
			'Smoochy',
			'Jiggly',
			'Admirable',
			'Impeccable',
			'Handsome',
			'Radical',
			'Sweet',
			'Peachy',
			'Pretty',
			'Trusty',
			'Delightful',
			'Charming',
			'Dreamy',
			'Exceptional',
			'Infinite',
			'Cozy',
			'Angelic',
			'Chocolate',
			'Pinchy',
			'Prickly',
			'Mr.',
			'Mrs.',
			'Miss',
			'Ms.',
			'Dr.',
			'Rainy',
			'Bumbly',
			'Lovey',
			'Formidable',
			'Lovely',
			'Gracious',
			'Sassy',
			'Swaggy',
			'Tipsy',
			'Mighty',
			'Strong',
			'Wise',
			'Evil',
			'Good',
			'Decent',
			'Fine',
			'Thirsty',
			'Hungry',
			'Fiery',
			'Dancing',
			'Loopy',
			'Caramel',
			'Vanilla',
			'Tubby',
			'Ferocious',
			'Glamorous',
			'Scandalous',
			'Coy',
			'Cunning',
			'Littlest',
			'Aunt',
			'Uncle',
			'Old Man',
			'Space',
			'Flubby',
			'Silly',
			'Meepy',
			'Guilty',
			'Innocent',
			'Sneaky',
			'Scoopy',
			'Glittery',
			'Scratchy',
			'Poofy',
			'Doinky',
			'Springy',
			'Prancy',
			'Freepy',
			'Creepy',
			'Dweeby',
			'Baby',
			'Teenage',
			'Terrible',
			'Munchy',
			'Snuggly',
			'Squeezable',
			'Huggable',
			'Kissy',
			'Dinky',
			'Spicy',
			'Big',
		],
	},
	last: {
		cat: [
			'Gato',
			'Pouncer',
			'Tiger',
			'Tigress',
			'Purr',
			'Kitten',
			'Scratcher',
			'Lion',
			'Meow',
		],
		wildcat: [
			'Gato',
			'Pouncer',
			'Tiger',
			'Tigress',
			'Purr',
			'Kitten',
			'Scratcher',
			'Lion',
			'Meow',
			'Wildling',
		],
		penguin: [
			'Icicle',
			'Freezer',
			'Igloo',
			'Blizzard',
			'Frostbiter',
			'Coldbrew',
			'Frost',
			'Brainfreeze',
			'Waddler',
		],
		dog: [
			'Poop Bag',
			'Pooper Scooper',
			'Barker',
			'Woofer',
			'Doggo',
			'Pupper',
			'Doggo',
			'Bolt',
			'Doge',
			'Digger',
			'Grryffindog',
			'Rex',
			'Spot ',
			'Flufferpupper',
			'Borker',
			'Pupperino',
			'Doggerino',
			'Doggerton',
			'Beethoven',
			'Smeller',
			'Sniffer',
			'Barkitecht',
			'Fuzz Aldrin',
			'Pupcake',
			'Slobberyn',
			'Ravenpaw',
			'Huffleruff',
			'Barkledore',
			'Rufflepuff',
			'Barksalot',
			'Woofington',
		],
		classicdoggo: [
			'Poop Bag',
			'Pooper Scooper',
			'Barker',
			'Woofer',
			'Doggo',
			'Pupper',
			'Doggo',
			'Bolt',
			'Doge',
			'Digger',
			'Grryffindog',
			'Rex',
			'Spot ',
			'Flufferpupper',
			'Borker',
			'Pupperino',
			'Doggerino',
			'Doggerton',
			'Beethoven',
			'Smeller',
			'Sniffer',
			'Barkitecht',
			'Fuzz Aldrin',
			'Pupcake',
			'Slobberyn',
			'Ravenpaw',
			'Huffleruff',
			'Barkledore',
			'Rufflepuff',
			'Barksalot',
			'Woofington',
			'Lab',
			'Retriever',
			'Lassie',
			'Fetcher',
			'Good Boy',
			'Good Girl',
		],
		turtle: [
			'Shell',
			'Blub',
			'Koopa',
			'Squirt',
			'Squirtle',
			'Sheldon',
			'Shrimp',
		],
		bear: [
			'Yeller',
			'Beast',
			'Growler',
			'Honey Stealer',
			'Bee Eater',
			'Ranger',
			'Camper',
			'Cub',
			'Bamboo',
			'Hibernator',
			'Tum Tum',
			'Pooh',
		],
		chicken: [
			'Birb',
			'Clucker',
			'Chicklet',
			'Chicken',
			'Flapper',
			'Karen',
		],
		seal: [
			'Bowling Ball',
			'Flipper',
			'Chub',
			'Ball',
			'Slapper',
			'Blubber',
			'Plump',
			'Pudge',
		],
		bunny: [
			'Jumper',
			'Hopper',
			'Cottontail',
			'Thumper',
			'Cinnabunny',
			'Binky',
		],
		shared: [
			'Bop-it',
			'Cheerio',
			'Chubchub',
			'Gooberton',
			'Fluffernutter',
			'Monster',
			'Bug',
			'Buddy',
			'Pooper',
			'McGooberson',
			'Nuttypants',
			'Goob',
			'Nuzzler',
			'Stinky',
			'Peanut',
			'Limabean',
			'Monkey',
			'Doodoo',
			'Beep',
			'Gremlin',
			'Babe',
			'Leader',
			'Bingo',
			'Skunk',
			'Zipper',
			'Zingo',
			'Dingbat',
			'Crumbcatcher',
			'Foof',
			'Cranberry',
			'Hijinx',
			'Ploop',
			'Wrinkle',
			'Whisper',
			'Trinket',
			'Donker',
			'Zap',
			'Moose',
			'Crab',
			'Tripper',
			'Cutie',
			'Dinker',
			'Fluff',
			'Cuddlebug',
			'Sneaker',
			'Snugglebug',
			'Snowglobe',
			'Honey',
			'Show-off',
			'Hufflepuff',
			'Vape',
			'Casper',
			'Killer',
			'Ratchet',
			'Eater',
			'Gobbler',
			'Beggar',
			'Beggar',
			'Bonker',
			'Biter',
			'Burglar',
			'Freep',
			'Nibbler',
			'Lump',
			'Bop',
			'Rainbow',
			'Whizbang',
			'Boo',
			'Freckles',
			'Giggles',
			'Meep',
			'Mipmop',
			'Twinkie',
			'Rager',
			'Button',
			'Leaper',
			'Bug',
			'Tush',
			'Burp',
			'Smooch',
			'Cupcake',
			'Chomper',
			'Piglet',
			'Treasurechest',
			'Doombringer',
			'Dinosaur',
			'Glitterbug',
			'Rhombus',
			'Twizzler',
			'Bubbles',
			'Elf',
			'Peaches',
			'Sherbert',
			'Pocky',
			'Cookie',
			'Coconut',
			'Raccoon',
			'Squirrel',
			'Sparkles',
			'Wobbles',
			'Weeble',
			'Basket',
			'Blip',
			'Blob',
			'Winky',
			'Knight',
			'Nightmare',
			'Prince',
			'Princess',
			'Peepers',
			'Pinky',
			'Pidgeon',
			'Mug',
			'Teaspoon',
			'Bubby',
			'Stinker',
			'Marshmallow',
			'Bob',
			'Tubbs',
			'River',
			'Snowball',
			'Booboo',
			'Bella',
			'Milkshake',
			'Wigwam',
			'Meeper',
			'Slipper',
			'Scooper',
			'Psychic',
			'Goober',
			'Pluto',
			'Jupiter',
			'Weirdo',
			'Poofball',
			'Doink',
			'Skipper',
			'Freeper',
			'Creeper',
			'Stingray',
			'Puff',
			'Doobie',
			'Dweeb',
			'Muncher',
			'Hugger',
			'Smoocher',
			'Lovebug',
			'Dumbledort',
			'Voldemorp',
			'Macaroni',
			'Spaghetti',
			'Chalupa',
			'Burrito',
			'Taquito',
			'Wingding',
			'Thunderball',
			'Dingbop',
			'Stomper',
			'Potato',
			'Ringpop',
			'Smasher',
		],
	},
};

function name(typeOfPet) {
	const firstNames = names.first[typeOfPet]
		? _.concat(names.first.shared, names.first[typeOfPet])
		: names.first.shared;
	const lastNames = names.last[typeOfPet]
		? _.concat(names.last.shared, names.last[typeOfPet])
		: names.last.shared;

	const thisName = {
		first: firstNames[_.random(firstNames.length - 1)],
		last: lastNames[_.random(lastNames.length - 1)],
	};

	thisName.full = `${thisName.first} ${thisName.last}`;
	thisName.special = isSpecial(thisName);

	return thisName;
}


// SPECIAL NAMES

const specialNameOptions = [
	'Casper',
	'Night',
	'Pinky',
	'Evil',
	'Rainbow',
	'Space',
	'Tiny',
	'Lil 404',
];

function isSpecial(name) {
	let special;

	specialNameOptions.forEach(function(specialName) {
		if (specialName === name.first || specialName === name.last || specialName === name.full) {
			special = specialName.replace(/\s+/g, '-');
		}
	})

	return special;
}


// CAT COLORS

const colorOptions = {
	cat: [
		'orange',
		'white',
		'gray',
		'black',
		'brown',
	],
	wildcat: [
		'orange',
		'white',
		'gray',
		'black',
		'gold',
	],
	dog: [
		'orange',
		'white',
		'gray',
		'black',
		'brown',
	],
	classicdoggo: [
		'orange',
		'white',
		'gray',
		'black',
		'brown',
		'gold',
		'orange-spot',
		'gray-spot',
		'black-spot',
		'brown-spot',
		'dark-brown-spot',
		'gold-spot',
	],
	penguin: [
		'orange',
		'black',
		'gold',
		'purple',
		'blue',
		'red',
	],
	bear: [
		'orange',
		'white',
		'gray',
		'black',
		'brown',
		'panda',
	],
	turtle: [
		'green',
		'blue',
		'purple',
		'yellow',
		'red',
	],
	chicken: [
		'white',
		'orange',
		'black',
		'brown',
	],
	seal: [
		'white',
		'black',
		'gray',
		'brown',
	],
	bunny: [
		'white',
		'gray',
		'cream',
		'gold',
		'brown',
		'black',
	],
	pig: [
		'white',
		'pink',
		'pink',
		'pink',
		'black',
		'brown',
		'orange',
	],
	shared: [],
};

function color(typeOfPet) {
	const colorsForThisPet = colorOptions[typeOfPet]
		? _.concat(colorOptions.shared, colorOptions[typeOfPet])
		: colorOptions.shared;

	const thisColor = colorsForThisPet[_.random(colorsForThisPet.length - 1)];

	return thisColor;
}


// LIKES PETS

const likesPetsOptions = [
	'likes',
	'hates',
];

function likesPets() {
	const likesPetsValue = Math.random() > 0.45 ? likesPetsOptions[0] : likesPetsOptions[1];

	return likesPetsValue;
}


// BODIES

const numOfBodies = 6;

function body() {
	let body = _.random(0, numOfBodies - 1);

	return body;
}


// HEADS

const numOfHeads = 2;

function head() {
	let head = _.random(0, numOfHeads - 1);

	return head;
}


// GLASSES

const glassesMap = {
	'glasses-1': 'Raybans',
	'glasses-2': 'CatEye',
	'glasses-3': 'ThreeD',
	'glasses-4': 'OldMan',
	'glasses-5': 'Scuba',
	'glasses-6': 'Kerry',
	'glasses-7': 'Blue',
	'glasses-8': 'Sunglasses',
};

const glassesOptions = [
	'Raybans',
	'CatEye',
	'ThreeD',
	'OldMan',
	'Scuba',
	'Kerry',
	'Blue',
	'Sunglasses',
];

function glasses() {
	let glasses = glassesOptions[_.random(glassesOptions.length*2)];

	return glasses;
}


// HATS

const hatMap = {
	'hat-1': 'PartyHat',
	'hat-2': 'Fedora',
	'hat-3': 'Fez',
	'hat-4': 'Chef',
	'hat-5': 'Baseball',
	'hat-6': 'Beanie',
	'hat-7': 'Princess',
	'hat-8': 'King',
	'hat-9': 'Unicorn',
	'hat-10': 'Sweatband',
	'hat-11': 'Spinner',
	'hat-12': 'Bow',
};

const hatOptions = [
	'PartyHat',
	'Fedora',
	'Fez',
	'Chef',
	'Baseball',
	'Beanie',
	'Princess',
	'King',
	'Unicorn',
	'Sweatband',
	'Spinner',
	'Bow',
];

function hat() {
	let hat = hatOptions[_.random(hatOptions.length*2)];

	return hat;
}


// TOYS

const toyMap = {
	'toy-1': 'Yarn',
	'toy-2': 'Mouse',
	'toy-3': 'Pizza',
	'toy-4': 'Fishbones',
	'toy-5': 'SoccerBall',
	'toy-6': 'Donut',
	'toy-7': 'Fishbowl',
	'toy-8': 'Campfire',
	'toy-9': 'MagicWand',
	'toy-10': 'IceCream',
	'toy-11': 'Coffee',
	'toy-12': 'MiniGolf',
	'toy-13': 'Flamingo',
	'toy-14': 'Rocketship',
	'toy-15': 'FoamFinger',
	'toy-16': 'BonsaiTree',
	'toy-17': 'Wine',
	'toy-18': 'Synth',
	'toy-19': 'Martini',
};

const toyOptions = [
	'Yarn',
	'Mouse',
	'Pizza',
	'Fishbones',
	'SoccerBall',
	'Donut',
	'Fishbowl',
	'Campfire',
	'MagicWand',
	'IceCream',
	'Coffee',
	'MiniGolf',
	'Flamingo',
	'Rocketship',
	'FoamFinger',
	'BonsaiTree',
	'Wine',
	'Synth',
	'Martini',
];

function toy() {
	let toy = toyOptions[_.random(toyOptions.length*2)];

	return toy;
}


// BG COLORS

const bgColorOptions = [
	'light-blue',
	'red',
	'blue',
	'light-purple',
	'purple',
	'green',
	'teal',
	'yellow',
	'mauve',
];

function bgColor() {
	let bgColor = bgColorOptions[_.random(bgColorOptions.length - 1)];

	return bgColor;
}


// GET A PLAIN CAT

function cat() {
	const thisCat = {
		petType: {
			sku: 'cat_tabbycat',
			type: 'cat',
			name: 'Cat',
		},
		name: name('cat'),
		color: color('cat'),
		likesPets: likesPets(),
		body: body(),
		head: head(),
		bgColor: bgColor(),
	};

	return thisCat;
}


// Get a random pet of type

function petOfTypeForPetPicker(type) {
	const randomPetOfType = {
		name: name(type),
		color: color(type),
		likesPets: likesPets(),
		body: body(),
		head: head(),
	};

	// TODO: Make sure we don't need to include `kitten: null` in here.
	return randomPetOfType;
}

function petOfTypeForInitialize(type) {
	const randomPetOfType = {
		name: name(type),
		color: color(type),
		bgColor: bgColor(),
		likesPets: likesPets(),
		body: body(),
		head: head(),
	};

	// TODO: Make sure we don't need to include `kitten: null` in here.
	return randomPetOfType;
}


module.exports = {
	name,
	color,
	likesPets,
	body,
	head,
	bgColor,
	glasses,
	hat,
	toy,
	cat,
	petOfTypeForPetPicker,
	petOfTypeForInitialize,
	maps: {
		toyMap,
		hatMap,
		glassesMap,
		goodyMap: _.merge(toyMap, hatMap, glassesMap),
	},
	options: {
		colorOptions,
		bgColorOptions,
		likesPetsOptions,
		toyOptions,
		hatOptions,
		glassesOptions,
		specialNameOptions,
		numOfHeads,
		numOfBodies,
	},
};



// WEBPACK FOOTER //
// ./src/utils/getRandom.js